import { ExternalLink } from 'lucide-react';
import { trpc } from '~/api/trpc';
import { Button } from '~/components/ui/button';

type ButtonOpenTreatmentPlannerProps = {
    customerId: number;
};

export const ButtonOpenTreatmentPlanner = ({ customerId }: ButtonOpenTreatmentPlannerProps) => {
    const myLoginTokenQuery = trpc.user.getMyLoginToken.useQuery();
    const { data: latestCourseDate, isLoading: isLoadingCourseDate } = trpc.customers.getLatestTreatmentCourseDate.useQuery({ customerId });

    return (
        <div className="flex flex-col items-start">
            <Button
                variant="ghost"
                size="default"
                className="w-full sm:w-auto"
                onClick={() => {
                    const baseUrl = import.meta.env.MODE === 'production'
                        ? 'https://treatmentplanner.kalialab.de'
                        : import.meta.env.MODE === 'staging'
                            ? 'https://staging.treatmentplanner.kalialab.de'
                            : 'http://localhost:3000';
                    window.open(`${baseUrl}/dashboard/patients/${customerId}${!!myLoginTokenQuery?.data ? `?user_token=${myLoginTokenQuery.data}` : ""}`, "_blank");
                }}
            >
                <ExternalLink className="h-4 w-4 mr-2" />
                Behandlungsplaner öffnen
            </Button>
            {!isLoadingCourseDate && (
                <p className="text-xs text-gray-400 ml-3 mt-0.5">
                    {latestCourseDate
                        ? `Behandlungsplan vorhanden vom ${new Date(latestCourseDate).toLocaleDateString('de-DE')}`
                        : 'Noch kein Behandlungsplan erstellt'}
                </p>
            )}
        </div>
    );
};
